import React from 'react';
import { motion } from 'framer-motion';
export function ProblemSection() {
  return <section className="bg-cream py-16 md:py-24 px-4" data-id="element-87">
      <div className="max-w-3xl mx-auto" data-id="element-88">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="bg-white p-8 md:p-12 rounded-2xl shadow-sm border border-amber/20" data-id="element-89">
          <h2 className="font-heading text-2xl md:text-3xl text-navy font-bold mb-6" data-id="element-90">
            El esfuerzo tradicional no funciona
          </h2>
          <div className="space-y-6 text-lg text-charcoal leading-relaxed font-body" data-id="element-91">
            <p data-id="element-92">
              Como padres hispanos en este país, nos enseñaron a ser fuertes y a
              "echarle ganas". Pero con la depresión adolescente, el esfuerzo
              tradicional no funciona.
            </p>
            <p data-id="element-93">
              Intentas preguntar "¿qué te pasa?", intentas darle consejos,
              intentas motivarlo... y lo único que logras es que se aleje más.
              Estás atrapado en un ciclo donde tu ayuda se convierte en el
              disparador de su enojo. Mientras tanto, el tiempo pasa y el
              aislamiento se vuelve más profundo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}